import store from '@/store'
import $mine from '@/utils/http/modules/mine/mine.request.js'

let requesting = false // 避免重复调用接口

/** 获取后台积分名称 */
export default function () {
  return new Promise(resolve => {
    if (!store.getters.integral.isRequest && !requesting) {
      requesting = true
      $mine
        .getIntegralBasic({
          zbid: window.zbvd.zbid,
        })
        .then(res => {
          if (res.code === 0) {
            store.commit('setIntegral', res.dataObj)
            resolve(res.dataObj)
          }
        })
        .catch(() => {
          store.commit('setIntegral', null)
          resolve(null)
        })
        .finally(() => {
          requesting = false
        })
    } else {
      resolve(store.getters.integral.integralInfo)
    }
  })
}
